export const REACT_VERSION = '18.3.1'
export const REACT_ESM_URL = `https://esm.sh/react@${REACT_VERSION}?dev`
export const REACT_DOM_ESM_URL = `https://esm.sh/react-dom@${REACT_VERSION}?dev`
